





































import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class ApproveForm extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @Prop({}) loading!: boolean;

  @Prop({}) urlFileName!: string;

  @Prop({}) urlFile!: string;

  public close() {
    this.$emit('cancel');
  }

  public onApprove() {
    this.$emit('approve');
  }
}
